import { render, staticRenderFns } from "./PointForm.vue?vue&type=template&id=869a1d5a&"
import script from "./PointForm.vue?vue&type=script&lang=js&"
export * from "./PointForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports